import React from 'react';
import Content from './Content';

export default function CompanyAdmin() {
    return (
        <div className="h-screen overflow-hidden bg-slate-50">
            <Content />
        </div>
    );
}
